"use client";

import { Button } from "@/components/ui/button";
import { ResourceContext } from "@/contexts/resource-context";
import { clientPost } from "@/service/client-api/client-api";
import { logEvent } from "@/service/logs/log";
import { useRouter } from "@bprogress/next";
import { useContext } from "react";
import { CourseChapterTestWrapper } from "@/components/course/chapter/test/course-chapter-test-wrapper";

export const FinalCourseQuiz = ({
  testContentBlocks,
  id,
  title,
  isTestActive,
  setIsTestActive,
}: {
  testContentBlocks: ContentBlock[];
  id: number;
  title: string;
  isTestActive: boolean;
  setIsTestActive: (isActive: boolean) => void;
}) => {
  const { logView } = useContext(ResourceContext);
  const router = useRouter();

  if (!isTestActive || testContentBlocks.length === 0) {
    return <></>;
  }

  return (
    <>
      <CourseChapterTestWrapper
        scroll={false}
        steps={testContentBlocks.map((block) => ({
          title: block.data.heading as string,
          content: [block],
        }))}
        handleFinish={async (score) => {
          if (!score) {
            return;
          }
          const logData = {
            questionCount: Object.keys(score).length,
            correctAnswerCount: Object.values(score).filter((s) => s.correct)
              .length,
          };

          logEvent("course_quiz_finish", logView, {
            logData,
          });

          clientPost(
            "course.quiz.finish",
            {},
            {
              ...logData,
              resourceType: "COURSE",
              resourceId: id.toString(),
            },
          );
        }}
        summaryData={{
          title: "Ukończono test",
          subtext: `Ukończono kurs "${title}"`,
          rightButton: (
            <Button
              variant={"blue"}
              onClick={() => {
                setIsTestActive(false);
                router.refresh();
              }}
            >
              Zakończ
            </Button>
          ),
        }}
      />
    </>
  );
};
